import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faPhone } from '@fortawesome/free-solid-svg-icons';

interface ContactInfoCardProps {
  stakeholderData: any;
}

const ContactInfoCard: React.FC<ContactInfoCardProps> = ({ stakeholderData }) => {
  return (
    <div className="stakeholder-details-card stakeholder-contact-card">
      <div className="stakeholder-card-header">
        <div className="stakeholder-card-header-left">
          <FontAwesomeIcon icon={faPhone} className="stakeholder-card-icon" />
          <h3 className="stakeholder-card-title">Contact Information</h3>
        </div>
      </div>
      <div className="stakeholder-card-content stakeholder-contact-grid">
        <div className="stakeholder-contact-row">
          <div>
            <div className="stakeholder-contact-label">Primary Email (Business)</div>
            <div className="stakeholder-contact-value">{stakeholderData.Email || 'N/A'}</div>
          </div>
          <button className="stakeholder-copy-button" aria-label="Copy">
            <FontAwesomeIcon icon={faCopy} />
          </button>
        </div>
        <div className="stakeholder-contact-row">
          <div>
            <div className="stakeholder-contact-label">Primary Phone (Business)</div>
            <div className="stakeholder-contact-value">{stakeholderData.Phone || 'N/A'}</div>
          </div>
          <button className="stakeholder-copy-button" aria-label="Copy">
            <FontAwesomeIcon icon={faCopy} />
          </button>
        </div>
        <div className="stakeholder-contact-row">
          <div>
            <div className="stakeholder-contact-label">Mobile Phone (Personal)</div>
            <div className="stakeholder-contact-value">{stakeholderData.Phone || 'N/A'}</div>
          </div>
          <button className="stakeholder-copy-button" aria-label="Copy">
            <FontAwesomeIcon icon={faCopy} />
          </button>
        </div>
        <div className="stakeholder-contact-row stakeholder-contact-address">
          <div>
            <div className="stakeholder-contact-label">Business Address</div>
            <div className="stakeholder-contact-value">{stakeholderData.Address || 'N/A'}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfoCard;

